import React, { useEffect, useRef, InputHTMLAttributes } from 'react';
import { IconBaseProps } from 'react-icons';
import { useField } from '@unform/core';

import { Container } from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
	name: string;
	icon?: React.ComponentType<IconBaseProps>;
}

const Input: React.FC<InputProps> = ({ name, ...rest }) => {
	const inputRef = useRef<HTMLInputElement>(null);
	const { fieldName, registerField, defaultValue } = useField(name);

	useEffect(() => {
		registerField({
			name: fieldName,
			ref: inputRef.current,
			path: 'value',
		});
	}, [fieldName, registerField]);

	return (
		<Container>
			<input defaultValue={defaultValue} ref={inputRef} {...rest} />
		</Container>
	);
};

export default Input;
